<template>
    <div class="pack-box gift-choice">
        <div class="pack-title">
            <img src="/images/fr_new_home/cadeau.svg" alt="cadeaux"/>
            <h3>Kies je <span class="orange-text">geschenk</span></h3>
        </div>
        <h6 class="text-uppercase orange-text">Krijg toegang tot een uitgebreide catalogus met geschenken</h6>
        <p>
            Consumeren gaat gepaard met keuzevrijheid. Testaankoop laat je daarom zelf je geschenk kiezen uit een
            uitgebreide catalogus.
        </p>
        <ul>
            <li>High-Tech</li>
            <li>Schoonheid & welzijn</li>
            <li>Lederwaren & sieraden</li>
            <li>Doe-het-zelf & tuinieren</li>
            <li>Klein elektro</li>
            <li>Decoratie & tafelbekleding</li>
            <li>Cadeaubonnen</li>
            <li>…</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "GiftChoiceList"
}
</script>

<style scoped>

</style>
